import SiteLayout from "@/components/feature/SiteLayout";
import PageHero from "@/components/base/PageHero";
import SectionDivider from "@/components/base/SectionDivider";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import PatientPrep from "@/pages/patient-info/components/PatientPrep";
import PatientDuring from "@/pages/patient-info/components/PatientDuring";
import PatientAfter from "@/pages/patient-info/components/PatientAfter";
import PatientSafety from "@/pages/patient-info/components/PatientSafety";
import PatientFaq from "@/pages/patient-info/components/PatientFaq";
import CtaSection from "@/pages/home/components/CtaSection";

export default function PatientInfo() {
  useDocumentMeta({
    title: "Hasta Bilgilendirme | d.mar Dental Görüntüleme Merkezi",
    description:
      "Dental görüntüleme öncesi hazırlık, çekim sırasında ve sonrasında bilmeniz gerekenler. Düşük doz güvenliği, hamilelik ve KVKK hakkında hasta bilgilendirme rehberi.",
    path: "/hasta-bilgilendirme",
  });

  return (
    <SiteLayout>
      <PageHero
        crumb="Hasta Bilgilendirme"
        eyebrow="Hasta Bilgilendirme"
        title="Çekim öncesinden sonrasına, bilmeniz gereken her şey"
        description="Diş hekiminiz film istediyse süreç sandığınızdan çok daha basit. Hazırlık, çekim ve sonrasında sizi nelerin beklediğini adım adım anlatıyoruz."
      />
      <PatientPrep />
      <SectionDivider />
      <PatientDuring />
      <SectionDivider />
      <PatientAfter />
      <SectionDivider />
      <PatientSafety />
      <SectionDivider />
      <PatientFaq />
      <CtaSection />
    </SiteLayout>
  );
}